import { DownloadTemplateFile, UploadBeacons } from "api/beacons.api";
import UploadFileForm from "components/FileUpload/UploadFileForm"
import { useRootStore } from "contexts/RootStore.context";
import { useNavigate } from "react-router-dom";
import { routePath } from "router/routePaths";
import { alertErrorMessage } from "utils/alerts";
import { NewBeaconsList } from "./NewBeaconsList";
import { Box, Vertical } from "gls";
import { style } from "typestyle";
import { colours } from "styling/colours";

export const NewBeacons = () => {
  const navigate = useNavigate()
  const { hasBeaconIntegration } = useRootStore()

  const downloadTemplate = () => {
    DownloadTemplateFile()
      .catch(() => {
        alertErrorMessage('Error downloading file');
      })
  }

  const onUpload = (file: File) => {
    return UploadBeacons(file)
      .then(() => navigate(`${routePath.beaconManagement}/list`))
  }

  return (
    <Vertical className={BoxStyle} spacing={15} sizing="stretch">
      <Box className={UploadBoxStyle}>
        <UploadFileForm
          objectTitle="Beacons"
          onDownloadTemplate={downloadTemplate}
          onUpload={onUpload}
          collapsible
        />
      </Box>
      {hasBeaconIntegration && <NewBeaconsList />}
    </Vertical>
  )
}

const BoxStyle = style({
  marginTop: "20px",
  overflow: "hidden"
})

const UploadBoxStyle = style({
  backgroundColor: colours.white,
  padding: "20px",
  overflowY: "scroll"
})
